import { Box, Typography } from "@mui/material";

import raplMark from "../../assets/rapl-mark.png";

interface LogoProps {
  compact?: boolean;
}

export const Logo = ({ compact = false }: LogoProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        minWidth: 0,
      }}
    >
      <Box
        component="img"
        src={raplMark}
        alt="RAPL"
        sx={{
          width: compact ? 36 : 40,
          height: compact ? 36 : 40,
          objectFit: "contain",
          flexShrink: 0,
        }}
      />
      {!compact && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 700,
              letterSpacing: "0.18em",
              fontSize: 13,
              lineHeight: 1.2,
              color: "text.primary",
            }}
          >
            RAPL
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              letterSpacing: "0.22em",
              fontSize: 10,
              color: "primary.main",
              lineHeight: 1.2,
            }}
          >
            ADMIN
          </Typography>
        </Box>
      )}
    </Box>
  );
};
